import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ReportCategoryListModel } from '../models/reports.model';
import { ConfigService } from './config.service';
import { EnvironmentType } from 'app/enums/environment-type.enum';

@Injectable()
export class ReportService {

    constructor(private http: HttpClient, private config: ConfigService) { }

    public GetReports(): Observable<ReportCategoryListModel> {
        // if(this.config.getEnvironmentType() == EnvironmentType.Demo)
        // {
        //     return throwError('Call not allowed for Demo environment!');
        // }
        return this.http.get<ReportCategoryListModel>(this.config.getApiRoute('api/v3/client-portal/reports/list/')).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse) => {
                return throwError(err.message);
            }));
    }

}

